var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("m.join_agency_apply"), name: "join" } },
            [
              _vm.shouldTabShow("join")
                ? _c("join-guild-management-page")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("m.leave_agency_apply"), name: "quit" } },
            [
              _vm.shouldTabShow("quit")
                ? _c("quit-guild-approval-page")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            {
              attrs: { label: _vm.$t("m.transfer-approval"), name: "transfer" }
            },
            [
              _vm.shouldTabShow("transfer")
                ? _c("trabsfer-audit-page")
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b719e184", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b719e184","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/anchor/AnchorManagement.vue
// module id = null
// module chunks = 